export class GitDiffResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aheadBy",
            "baseName": "aheadBy",
            "type": "number",
            "format": ""
        },
        {
            "name": "behindBy",
            "baseName": "behindBy",
            "type": "number",
            "format": ""
        },
        {
            "name": "entries",
            "baseName": "entries",
            "type": "Array<GitDiffEntry>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitDiffResponse.attributeTypeMap;
    }
    constructor() {
    }
}
